import React, { useContext, useEffect, useState } from 'react';

import MemberReferralCard from './MemberReferralCard';
import FireDataContext from '../../../services/firebase/FireDataContext';
import AuthContext from '../../../services/firebase/AuthContext';
import Grid from '@material-ui/core/Grid'

const MemberReferralsGrid = () => {
    const db = useContext(FireDataContext);
    const { currentUser: { uid } } = useContext(AuthContext);

    const [referrals, setReferrals] = useState();

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: `intermediaries/${uid}/referrals`,
            hook: data => {
                
                (async () => {
                    for (const rfq of data) {
                        rfq.referral = await db.get({ path: rfq.referralPath });
                    }
                    setReferrals(data);
                })();

            }
        });

        return unsubscribe;
    }, [db, uid])


    if (!referrals) return <></>;

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        referrals
                            .filter(ref => /new/i.test(ref.status))
                            .sort((a, b) => a.ts - b.ts).map(rfq => {
                                return <MemberReferralCard key={rfq.id} rfq={rfq} />
                            })
                    }
                </Grid>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        referrals
                            .filter(ref => /active/i.test(ref.status))
                            .sort((a, b) => a.ts - b.ts).map(rfq => {
                                return <MemberReferralCard key={rfq.id} rfq={rfq} />
                            })
                    }
                </Grid>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        referrals
                            .filter(ref => /completed/i.test(ref.status) || /declined/i.test(ref.status))
                            .sort((a, b) => b.ts - a.ts).map(rfq => {
                                return <MemberReferralCard key={rfq.id} rfq={rfq} />
                            })
                    }
                </Grid>
            </Grid>
        </div>
    );
};

export default MemberReferralsGrid;